import { render, staticRenderFns } from "./OldMatterProgramView.vue?vue&type=template&id=d7981fd6&scoped=true"
import script from "./OldMatterProgramView.vue?vue&type=script&lang=js"
export * from "./OldMatterProgramView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7981fd6",
  null
  
)

export default component.exports